/** S3-backed image CDN only — not the Firebase/site CloudFront domain. */
const S3_CDN_BASE = String(import.meta.env.VITE_S3_IMAGE_CDN_URL || '').trim().replace(/\/$/, '');
const LEGACY_CDN_BASE = String(import.meta.env.VITE_ASSET_CDN_URL || '').trim().replace(/\/$/, '');
const CDN_BASE = S3_CDN_BASE || LEGACY_CDN_BASE;

export function getAssetCdnBase() {
  return CDN_BASE;
}

export function isS3ImageCdnConfigured() {
  return Boolean(S3_CDN_BASE);
}

export function assetKeyFromUrl(urlString) {
  const trimmed = String(urlString || '').trim();
  if (!trimmed) return '';

  if (CDN_BASE) {
    try {
      const u = new URL(trimmed);
      const cdnHost = new URL(CDN_BASE).hostname.toLowerCase();
      if (u.hostname.toLowerCase() === cdnHost) {
        const path = (u.pathname || '/').replace(/^\//, '');
        return path ? decodeURIComponent(path.replace(/\+/g, ' ')) : '';
      }
    } catch {
      /* fall through */
    }
  }

  const marker = '.amazonaws.com/';
  const idx = trimmed.indexOf(marker);
  if (idx >= 0) {
    return decodeURIComponent(trimmed.slice(idx + marker.length).split('?')[0].replace(/\+/g, ' '));
  }
  return '';
}

/** Rewrite S3 URLs to CloudFront only when a dedicated S3 image CDN is configured. */
export function toAssetCdnUrl(urlString) {
  const raw = String(urlString || '').trim();
  if (!raw || !S3_CDN_BASE) return raw;

  // Relative object keys (e.g. images/foo.jpg) stored without host
  if (!/^https?:\/\//i.test(raw) && !raw.startsWith('data:') && !raw.startsWith('blob:') && !raw.startsWith('//')) {
    const key = raw.replace(/^\//, '');
    if (key && !key.includes('://') && !key.includes('..')) {
      return `${S3_CDN_BASE}/${key}`;
    }
    return raw;
  }

  try {
    if (new URL(raw).hostname.toLowerCase() === new URL(S3_CDN_BASE).hostname.toLowerCase()) {
      return raw;
    }
  } catch {
    return raw;
  }

  const key = assetKeyFromUrl(raw);
  if (!key) return raw;
  return `${S3_CDN_BASE}/${key}`;
}

export function isCdnConfigured() {
  return Boolean(S3_CDN_BASE);
}
